import React from 'react';
import classnames from 'classnames';
import { Link } from 'gatsby';
import { Layout, Section, SEO } from '..';

import img from './assets/404.png';
import style from './NotFoundPage.module.less';

export const NotFoundPage = () => (
  <Layout>
    <SEO title="404: Not found" />
    <Section className={classnames(style.section, style.firstSection)}>
      <div className={classnames(style.contentNarrow, style.contentNotFound)}>
        <img src={img} className={style.notFoundImage} alt="Page Not Found" />
        <h1>404: This trail leads nowhere...</h1>
        <p><Link to="/">Return to the main page</Link></p>
      </div>
    </Section>
  </Layout>
);

export default NotFoundPage;
